import { render, staticRenderFns } from "./progresso-bancada.vue?vue&type=template&id=83c6cf4e&"
import script from "./progresso-bancada.vue?vue&type=script&lang=js&"
export * from "./progresso-bancada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports